import api from '@/api/index.js'

const system_accounts = {
  state: {
    loading: false,
    all: [],
    error: null
  },

  mutations: {
    SET_SYSTEM_ACCOUNTS_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_SYSTEM_ACCOUNTS: (state, all) => {
      state.all = all;
      state.loading = false;
    },
    SET_SYSTEM_ACCOUNTS_ERROR: (state, error) => {
      if (!error) {
        state.error = null;
        return
      }

      state.error = error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText;
      state.loading = false;
      state.updating = false;
    },
  },

  actions: {
    LoadSystemAccounts({commit}) {
      commit('SET_SYSTEM_ACCOUNTS_LOADING', true)
      commit('SET_SYSTEM_ACCOUNTS_ERROR', null)
      return api.get('system-accounts?limit=0&offset=0')
        .then((response) => {
          commit('SET_SYSTEM_ACCOUNTS', response)
        })
        .catch((error) => {
          commit('SET_SYSTEM_ACCOUNTS_ERROR', error);
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText);
        })
    },
  }
}

export default system_accounts
